<template>
  <div class="right">
    <div class="content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideBarComponent",
};
</script>

<style lang="scss" scoped>
.right {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 32%;
  display: flex;
  align-items: center;
  padding: 0 100px 0 70px;
}

.content {
  width: 100%;
}
</style>
